<template>
 
		<v-container>
      <v-row class="theContainer">
       <v-col
       cols="12" md="4"
          
          
        >
        <sideSection v-if="rendered" class="mr-12"/>
        
         	
        </v-col>
      
        
        <v-col cols="12" md="8">
         <v-card shaped class="shapedto" elevation="3">
            	
              
      <v-row justify="center">
					<v-col cols="auto">
          <v-img
            height="210"
            width="300"
            src="idmaj.png"
          ></v-img>
        </v-col>
        <v-col cols="auto" xl="12">
                    <v-card-text> 
                    <p class="text--primary">
                        Créée en 2006 sur la volonté de différents acteurs locaux et des pouvoirs publics, Casablanca Iskane et Equipement, est une société anonyme chargée de la résorption de l’habitat insalubre dans la Région Casablanca-Settat.
                        <br>

La mission de la société de développement local est de renforcer l’activité des opérateurs privés et publics déjà engagés dans la gestion de la résorption des bidonvilles et de permettre l'intégration des quartiers insalubres et sous-équipés de la Région de Casablanca-Settat.
                    </p>   

                    <p class="text--primary">
                        Pour se faire, nos champs d'action sont multiples : 
                        <ul class="mt-3">
                        <li>Résorption / recasement des bidonvilles</li>
                        <li>Résorption de l'habitat menaçant ruine (HMR)</li>
                        <li>Accompagnement de la population à transférer sur le plan social, technique, financier et équipement de proximité</li>
                        <li>Accompagnement de propriétaires terriens dans l'évacuation des terrains occupés</li>
                        <li>Réception des participations des promoteurs suite aux dérogations pour le compte de la collectivité</li>
                        <li>Accompagnement en Maîtrise d'Ouvrage Déléguée pour la réalisation de certains projets locaux.</li>
                        </ul>
                         

                        


                        


                    </p>
                    </v-card-text>
        </v-col>
      </v-row>
            
                    
                    

		
				
         </v-card>
        </v-col>
       
      </v-row>
    
			
      
            
		</v-container>
       

</template>

<script>

import sideSection from "@/components/navbarComponents/sideSection";



export default {
    components: {
     sideSection
    },
    methods: {
        checkRendering() {
        this.$store.state.toRender = true;
      }
    },
    created() {
        this.checkRendering();
    },
    computed: {
        rendered() {
          return this.$store.state.toRender;
        },
    },
    
data: () => ({
    overlay: false,
    flex: [4,6,3],
    show: false,
    cards: [
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 4, text: 'Lorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem' },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 4, text: 'Lorem Ipsum Lorem Ipsum' },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
    ],
    
    
    }),
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');


.sp-title{
    color: #1976d2;
}
.divimagestuff{
    margin: 0px;
    margin-bottom: 16px;
    padding: 0px;
    height: 5cm;
}

p {
    font-family: "Karla";
}

.imagestuff{
 margin: 0%;
 padding: 0%;
 height:100%; 
 width:70% ;
}
.container{
 height:50%;
 margin-bottom: 0%;
 padding-bottom: 0%;
}

.row{
    padding-bottom: 2rem;
}



.subcontainer {
    display:flex
}
.inerventionbuttonclass{
    margin-left: 0.8rem;
}

.v-container {
    max-width: 1150px !important;
}


.contain {
    margin-inline-start: 80px;
    margin-bottom: 12px;
}





@media only screen 
    and (device-width : 1920px) 
    and (device-height : 1080px) { 
  .v-card
  {
    margin-left: 24px !important;
    width: 87%;
  } 
    }





.shapedto {
  border-radius: 30px;
  
}


@media (min-width: 1800px)  {
  .theContainer{
  padding-bottom: 2rem;
  padding-left: 10rem;
  padding-right: 10rem;
  display: flex;
}
}
</style>